import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ColumnsSettingsModalComponent, type ColumnsSettingsModalProps,
} from './columnsSettingsModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ColumnsSettings: ColumnsSettingsModalProps;
  }
}
modalRenderer.register('ColumnsSettings', ColumnsSettingsModalComponent);
